import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskLoyaltyConnectionPageConfig } from '@front-platform/content-builder';
import { kioskLoyaltyConnectionPageResolveConfig } from '@front-platform/content-builder';
import { Component, ElementRef, HostBinding, OnInit, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { CartService } from '@core/services/cart/cart.service';
export interface KioskLoyaltyConnectionPageRuntimeConfig {
  'header'?: unknown[] | undefined;
  'body'?: any;
  'footer'?: any;
}

export type KioskLoyaltyConnectionPageConfigInput = Partial<
  Omit<KioskLoyaltyConnectionPageConfig, keyof KioskLoyaltyConnectionPageRuntimeConfig> &
    KioskLoyaltyConnectionPageRuntimeConfig
>;
export type KioskLoyaltyConnectionPageResolvedConfig = Omit<
  KioskLoyaltyConnectionPageConfig,
  keyof KioskLoyaltyConnectionPageRuntimeConfig
> &
  Partial<KioskLoyaltyConnectionPageRuntimeConfig>;
export interface KioskLoyaltyConnectionPageContract extends ConfigComponentContract<
  KioskLoyaltyConnectionPageConfigInput,
  KioskLoyaltyConnectionPageResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-loyalty-connection-page',
  templateUrl: './kiosk-loyalty-connection-page.component.html',
  standalone: false,
})
export class KioskLoyaltyConnectionPageComponent
  implements OnInit, KioskLoyaltyConnectionPageContract
{
  readonly config = input<KioskLoyaltyConnectionPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskLoyaltyConnectionPageConfig,
    KioskLoyaltyConnectionPageRuntimeConfig
  >(kioskLoyaltyConnectionPageResolveConfig, () => ({ config: this.config() }));
  get header(): unknown[] | undefined {
    return this.resolvedConfig()['header'] as unknown as unknown[] | undefined;
  }
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }
  get footer(): any {
    return this.resolvedConfig()['footer'] as unknown as any;
  }

  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get backgroundImage(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['background_image'] as unknown as
      IContentBuilderFieldImage | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }

  @HostBinding('class') classes = 'h-screen flex';

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
    private readonly el: ElementRef,
    private readonly cartService: CartService,
  ) {
    this.cartService.loadShopsOfCart$().subscribe();
  }

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      '/' + this.activatedRoute.snapshot.url.join('/'),
      this.activatedRoute.snapshot,
    );

    if (this.textColor?.value) {
      this.setTextOverrideColor();
    }
  }

  setTextOverrideColor(): void {
    const textColor = this.textColor?.value;
    this.el.nativeElement.style.setProperty('--my-class-bg-color', textColor);
  }

  get hasBackgroundImage(): boolean {
    return !!this.backgroundImage?.url;
  }

  getBackgroundStyles() {
    const url = this.backgroundImage?.url;
    return {
      'background-image': url ? `url(${url})` : null,
      'background-size': url ? 'cover' : null,
      'background-position': url ? 'center' : null,
      'background-repeat': url ? 'no-repeat' : null,
    };
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskLoyaltyConnectionPageComponent, {
  'keyAliases': {},
});
